import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";
import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import useFetcher from "@/utils/use-fetcher";

export interface ParseOrderRulesToConditionsParameter {
  lineSheetSetId: number;
}

export interface ParseOrderRulesToConditionsRequest {}

export interface ParseOrderRulesToConditionsBrandCondition {
  subCategory: string | null;
  priceAdjustedBy: {
    by: "MARKUP" | "DISCOUNT";
    value: number;
    applyIva: boolean | null;
  };
}

export interface ParseOrderRulesToConditionsBrand {
  brandId: number;
  brandName: string;
  conditions: ParseOrderRulesToConditionsBrandCondition[];
}

// 비동기 작업 결과(job 완료 시 result로 반환되는 형태)
export interface ParseOrderRulesToConditionsResult {
  brands: ParseOrderRulesToConditionsBrand[];
  unmatched: string[];
}

// POST 응답: 작업을 시작하고 job_id만 즉시 반환한다.
export interface ParseOrderRulesToConditionsResponse {
  jobId: string;
  status: string;
}

// 매칭된 룰을 칩 형태로 보여줄 때 쓰는 라벨 포맷터.
// 예) "RTW: Markup 10%", "Discount 20% (IVA)"
export function formatMatchedConditionLabel(
  c: ParseOrderRulesToConditionsBrandCondition
): string {
  const byLabel = c.priceAdjustedBy.by === "MARKUP" ? "Markup" : "Discount";
  const ivaSuffix = c.priceAdjustedBy.applyIva ? " (IVA)" : "";
  const prefix =
    c.subCategory && c.subCategory.trim() !== ""
      ? `${c.subCategory.trim()}: `
      : "";
  return `${prefix}${byLabel} ${c.priceAdjustedBy.value}%${ivaSuffix}`;
}

export const parseOrderRulesToConditionsTemplateUrl =
  "/line-sheet-sets/:lineSheetSetId/parse-order-rules-to-conditions";

export const parseOrderRulesToConditionsKey: YWRKey<ParseOrderRulesToConditionsParameter> =
  {
    url: (parameter) =>
      calcUrl(parseOrderRulesToConditionsTemplateUrl, parameter),
    method: "post",
  };

export default function useParseOrderRulesToConditions() {
  const fetcher = useFetcher<
    ParseOrderRulesToConditionsRequest,
    ParseOrderRulesToConditionsResponse
  >();
  return useYWR(parseOrderRulesToConditionsKey, fetcher);
}
